export default {
	copyright: 'COPYRIGHT 2023-AIRCLASS(SINGAPORE)PTE',
	ltd: 'LTD, AIRCLASS (HK) LIMITED - ALL RIGHTS RESERVED',
	ltd2: '沪ICP备2022013021号-4',
	list: [
		{
			id: 1,
			title: 'Enlaces Rápidos',
			content: [
				{
					icon: '',
					name: 'Sobre Airclass',
					link: '/:countryCode/main-home#school',
					eventId: 'ACW_footer_aboutus',
				},
				{
					icon: '',
					name: 'Equipos y Carreras',
					link: '/:countryCode/teams-careers',
					eventId: 'ACW_footer_teams',
				},
				{
					icon: '',
					name: 'Únete a nosotros',
					link: '/:countryCode/join-us',
					eventId: 'ACW_footer_joins',
				},
				{
					icon: '',
					name: 'Para Padres',
					link: '/:countryCode/for-parents',
					eventId: 'ACW_footer_parents',
				},
				{
					icon: '',
					name: 'Asóciate con nosotro',
					link: '/:countryCode/partner',
					eventId: 'ACW_footer_partner',
				},
			],
			flex: []
		},
		{
			id: 2,
			title: 'Contáctanos',
			content: [
				{
					icon: 'https://web-data.zmlearn.com/image/2cntRomEexezxsGdDtbqjH/icon_footer_email%402x.png',
					name: 'contact@air-class.com',
					link: '',
				},
				{
					icon: 'https://web-data.zmlearn.com/image/3dsHUWPmvthjE3P9qvbCWy/icon_footer_phone%402x.png',
					name: '+34 644 038 158',
					link: '',
				},
				{
					icon: 'https://web-data.zmlearn.com/image/5VG34WoNbNu1niu17tXhTS/icon_footer_service%402x.png',
					name: 'service01@air-class.com',
					link: '',
				},
			],
			flex: []
		},
		{
			id: 4,
			title: 'AirClass华人',
			content: [
				{
					icon: 'https://web-data.zmlearn.com/image/iQuSNHiDptiQDKDRCE251A/icon_link.png',
					name: 'www.airclasskids.com',
					link: 'http://airclasskids.com/',
				},
			],
			flex: [
				{
					id: 3,
					title: 'Conviértete en tutor',
					content: [
						{
							icon: 'https://web-data.zmlearn.com/image/2cntRomEexezxsGdDtbqjH/icon_footer_email%402x.png',
							name: 'tutor@air-class.com',
							link: '',
						},
					],
				}
			]
		},
	],
};
